// jQuery, Vue etc
require('./bootstrap')
require('./menu')
require('./webinar')
require('jquery-match-height')
require('bootstrap')

const container = document.getElementById("counter-container");
const wrapper = document.getElementById("menu-mobile-wrapper");
if (container && wrapper) {
    require('./counter')
    wrapper.classList.add("counter");
}

window.$ = require('jquery')
window.Vue = require('vue')

Vue.component('event-registration-form', require('./components/EventRegistrationForm').default)
Vue.component('newsletter-form', require('./components/NewsletterForm').default)
Vue.component('members-filtering', require('./components/MembersFiltering').default)
Vue.component('speaker-filtering', require('./components/SpeakerFiltering').default)
Vue.component('speaker-stars', require('./components/SpeakerStars').default)
Vue.component('speaker-stars-input', require('./components/SpeakerStarsInput').default)
Vue.component('speaker-toggle-review-form', require('./components/ToggleReviewForm').default)
Vue.component('speaker-blocks-accordion', require('./components/blocks/Accordion').default)
Vue.component('speaker-blocks-review', require('./components/blocks/Review').default)

new Vue({
    el: '#app',
})

$('.equal-height').matchHeight()

// Event page
$(document).ready(function () {
    let eventStickyButton = $('.event-sticky-bar')

    if (eventStickyButton.length) {
        let registerButton = $('.event-registration-button')

        $(window).scroll(function () {
            if (registerButton.isAboveViewport()) {
                eventStickyButton.removeClass('is-stuck')
            } else {
                eventStickyButton.addClass('is-stuck')
            }
        })
    }
})

import LazyLoad from 'vanilla-lazyload'
import subToPod from './sub-to-pod'
import imageGallery from './gallery'
import slider from './slider'
import webinar from './webinar'

var lazyload = new LazyLoad({
    elements_selector: '.lazy',
    callback_set: function (element) {
        element.removeAttribute('height')
        element.removeAttribute('width')
    },
})

$('.js-newsletter-button').click(function () {
    ga('send', 'event', 'newsletter', 'click', 'subscription')
})

$('.js-interested-event-button').click(function () {
    ga('send', 'event', 'event', 'click', 'interest')
})

$('.js-enrollment-event-button').click(function () {
    ga('send', 'event', 'event', 'click', 'enrollment')
})

const subTrigger = document.querySelector('.js-sub-trigger')

if (subTrigger) {
    subToPod(subTrigger)
}

const membershipsGallery = document.querySelector('#memberships-gallery')
if (membershipsGallery) {
    imageGallery(membershipsGallery)
}
const membershipSlider = document.querySelector('.splide')
if (membershipSlider) {
    slider()
}
const videoWrapper = document.querySelector('.video-wrapper')
if (videoWrapper) {
    webinar()
}

// Set a data attribute to check if the select has a value.
const elements = document.querySelectorAll('select')
elements.forEach((element) => {
    element.dataset.placeholder = true
    element.addEventListener('change', function (e) {
        if (e.target.value === '') {
            element.dataset.placeholder = true
        } else {
            element.dataset.placeholder = false
        }
    })
})
